import { setSnackbarMessage } from 'actions/snackbar';
import client from 'core/axios';

import commonUpload from 'utils/commonUpload';

export const populateAccountSettings = settings => ({
  type: 'POPULATE_ACCOUNT_SETTINGS',
  settings,
});

export const rollbackNotificationPreferencesAction = () => ({
  type: 'ROLLBACK_NOTIFICATION_PREFERENCES',
});

export const setAccountSettingsLoading = mode => ({
  type: 'SET_ACCOUNT_SETTINGS_LOADING',
  mode,
});

export const setAvatarImageUploading = mode => ({
  type: 'SET_AVATAR_IMAGE_UPLOADING',
  mode,
});

export const retrieveUserDetails = () => async dispatch => {
  try {
    const { data } = await client.get(`v1/sl_users/me/`);
    dispatch(populateAccountSettings({ ...data }));
  } catch (e) {
    console.warn('Failed to retrieve user details', e);
  }
};

export const retrieveAccountSettings = () => async dispatch => {
  dispatch(setAccountSettingsLoading(true));
  try {
    const { data } = await client.get(`v1/sl_users/me/`);
    const { data: data2 } = await client.get(`v1/sl_users/user/`);

    dispatch(populateAccountSettings({ ...data, birthday: data2?.birthday }));
  } catch (e) {
    console.warn('Failed to retrieve account settings', e);
  }
  dispatch(setAccountSettingsLoading(false));
};

export const updateProfilePic = picture => ({
  type: 'UPDATE_PROFILE_PIC',
  picture,
});

export const uploadProfileImage = picture => async dispatch => {
  try {
    const res = await client.patch(`v1/sl_users/me/`, {
      picture,
    });
    if (res && res.status === 200) {
      await dispatch(updateProfilePic(res.data.picture));
      await dispatch(retrieveAccountSettings());
      dispatch(setSnackbarMessage({ message: 'Avatar Updated!' }));
    }
  } catch (e) {
    console.warn('Failed to upload profile image', e);
  }
  return null;
};

export const uploadAvatarImage = imageBlob => async dispatch => {
  dispatch(setAvatarImageUploading(true));
  const form = new FormData();
  form.append('avatar', imageBlob, 'avatar.png');
  const avatar = form.get('avatar');
  commonUpload(avatar, undefined).then(({ key }) => {
    dispatch(uploadProfileImage(key));
    dispatch(setAvatarImageUploading(false));
  });
};

export const removeProfileImage = () => async dispatch => {
  try {
    const res = await client.patch(`v1/sl_users/me/`, {
      picture: '',
    });
    if (res && res.status === 200) {
      await dispatch(updateProfilePic(res.data.picture));
      await dispatch(retrieveAccountSettings());
      dispatch(setSnackbarMessage({ message: 'Avatar Picture Deleted!' }));
    }
  } catch (e) {
    console.warn('Failed to remove image', e);
  }
};

export const updateSecondaryEmail = email => async dispatch => {
  await client.patch(`v1/sl_users/me/`, {
    secondaryEmail: email,
  });
  dispatch(setSnackbarMessage({ message: 'Alternative Email Added!' }));
  dispatch(retrieveAccountSettings());
};

export const deleteSecondaryEmail = () => async dispatch => {
  await client.patch(`v1/sl_users/me/`, {
    secondaryEmail: null,
  });
  dispatch(retrieveAccountSettings());
};

export const updatePrimaryEmail = email => async dispatch => {
  const res = await client.post(`v1/sl_users/change-email/`, {
    email,
  });
  if (res.status === 200) {
    dispatch(retrieveAccountSettings());
  }
  return res;
};

export const toggleEmailNotifications = currentPreference => () =>
  client.post(`v1/notifications/preference/`, {
    emailNotification: currentPreference ? null : 'Real Time',
    pushNotification: true,
  });

export const sendResetPassword = email => () =>
  client.post(`v1/sl_users/forgot/`, {
    email,
  });

export const populateDistrictSettings = districtSettings => ({
  type: 'ACCOUNT_SETTINGS/POPULATE_DISTRICT_SETTINGS',
  districtSettings,
});

export const fetchDistrictSettings = () => async dispatch => {
  try {
    const { status, data } = await client.get(
      `v1/sl-schools/district-settings/`,
    );
    if (status === 200) dispatch(populateDistrictSettings(data));
  } catch (e) {
    console.warn('Failed to get district settings', e);
  }
};

export const retrieveStaffProfile = staffId => async dispatch => {
  try {
    const { data, status } = await client.get(
      `v1/sl_users/k12-admins/${staffId}/profile`,
    );
    if (status === 200) {
      dispatch({
        type: 'ACCOUNT_SETTINGS/POPULATE_STAFF_PROFILE',
        staffProfile: data,
      });
    }
  } catch (e) {
    console.warn('Unable to retrieve Staff Profile', e);
  }
};

export const updateStaffProfile =
  ({ staffId, update }) =>
  async dispatch => {
    try {
      const { data, status } = await client.post(
        `v1/sl_users/k12-admins/${staffId}/profile`,
        update,
      );
      if (status === 201) {
        dispatch({
          type: 'ACCOUNT_SETTINGS/POPULATE_STAFF_PROFILE',
          staffProfile: data,
        });
        dispatch(setSnackbarMessage({ message: 'Staff Profile Updated!' }));
      }
    } catch (e) {
      console.warn('Unable to update Staff Profile', e);
    }
  };
